import request from "../../Requests/requests";
import { loadWorkTime } from "../../store/WorkTimeStore/WorkTimeReducer";

export const addWorkTime = (payload) => {
    return async dispatch => {
        await request.put('/Time/WorkTime/', { userId: localStorage.getItem('token'), 
        time: payload.workTime});
        dispatch(loadWorkTime(payload));
    } 
}